<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-6">
                <help-text>
                    <h3>
                        Portals
                    </h3>

                    <p>
                        This list displays the portals that the person is relevant for.
                    </p>

                    <p>
                        If the external ID field is filled out, the person exists on the portal.
                    </p>

                    <button
                            type="button"
                            class="btn btn-sm btn-black"
                            data-toggle="modal"
                            data-target="#create-person-portal-modal"
                    >
                        <i class="fa fa-plus"></i> Add Portal
                    </button>
                </help-text>
            </div>

            <div class="col-xs-18">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <table class="table table-condensed table-striped">
                            <thead>
                                <tr>
                                    <th class="col-xs-2 text-center">
                                        <input type="checkbox" :disabled="true">
                                    </th>

                                    <th class="col-xs-10">
                                        Portal
                                    </th>

                                    <th class="col-xs-10">
                                        External ID
                                    </th>

                                    <th class="col-xs-2"></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="portal in person.data.portals">
                                    <td class="text-center">
                                        <input type="checkbox" :disabled="true">
                                    </td>

                                    <td>
                                        <router-link :to="'/portals/' + portal.id">
                                            {{ portal.name }}
                                        </router-link>
                                    </td>

                                    <td>
                                        {{ portal.pivot.external_id }}
                                    </td>

                                    <td class="text-right">
                                        <div class="btn-group list-actions">
                                            <button type="button" class="btn btn-sm" @click="edit(portal)">
                                                <i class="fa fa-search"></i>
                                            </button>

                                            <button type="button" class="btn btn-sm" @click="destroy(portal)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>

                                <tr v-if="!person.data.portals.length">
                                    <td colspan="4" class="text-center">
                                        <i>
                                            There are no portals to display.
                                        </i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <create-person-portal-modal
                :person="person"
                @created="$emit('person-updated', $event)"
        ></create-person-portal-modal>

        <edit-person-portal-modal
                :person="person"
                :portal="editing"
                @updated="$emit('person-updated', $event)"
        ></edit-person-portal-modal>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import moment from 'moment'
    import notify from '@/notify'
    import CreatePersonPortalModal from '@/components/Modals/People/CreatePersonPortalModal'
    import EditPersonPortalModal from '@/components/Modals/People/EditPersonPortalModal'
    import HelpText from '@/components/HelpText'

    export default {
        components: {CreatePersonPortalModal, EditPersonPortalModal, HelpText},

        model: {
            prop: 'person',
            event: 'person-updated'
        },

        props: ['person'],

        data() {
            return {
                editing: null
            }
        },

        methods: {
            edit(portal) {
                this.editing = portal

                $('#edit-person-portal-modal').modal('show')
            },

            destroy(portal) {
                modal.confirm('Are you sure that you want to delete the portal?', () => {
                    this.getDestroyPromise(portal)
                        .then(response => {
                            notify.success('The portal was deleted')

                            this.$emit('person-updated', response.data)
                        })
                })
            },

            getDestroyPromise(portal) {
                return http.delete('/api/v1/people/' + this.person.data.id + '/portals/' + portal.id)
            }
        }
    }
</script>
